(function() {
    const submenuButtons = document.querySelectorAll('button:has(+ .submenu)')
    const mobileMenuButton = document.querySelector('#mobile-menu-toggle')
    const megaMenuButtons = document.querySelectorAll('button.mega-menu-toggle')
    const closeButtons = document.querySelectorAll('button.close-button')
    const jumpToTopButton = document.querySelector('#jump-to-top')

    const pageHeight = window.innerHeight + 50;

    mobileMenuButton.addEventListener('click', (e) => {
        e.target.classList.toggle('open')
    })
    
    submenuButtons.forEach(button => {
        button.addEventListener('click', (e) => {
            if (window.openMegaMenu) {
                const menuToClose = document.getElementById(window.openMegaMenu)
                const buttonToFix = document.querySelector(`[data-menu-id="${window.openMegaMenu}"]`)
                if (menuToClose) {
                    menuToClose.classList.remove('open')
                    window.openMegaMenu = null
                }
                if (buttonToFix) {
                    buttonToFix.classList.remove('open')
                }
            }
            if (window.openSubMenu && window.openSubMenu !== e.target) {
                    window.openSubMenu.classList.remove('open')
            }
            e.target.classList.toggle('open')
            window.openSubMenu = e.target
        })
    })

    megaMenuButtons.forEach(button => {
        button.addEventListener('click', e => {
            const menuId = e.target.dataset.menuId
            const menu = document.getElementById(menuId)

            //close any open submenu
            if (window.openSubMenu) {
                window.openSubMenu.classList.remove('open')
                window.openSubMenu = null
            }
            
            // if there is an open menu, close it
            if (window.openMegaMenu) {
                if (window.openMegaMenu === menuId) {
                    //closing this menu 
                    if (menu) menu.classList.remove('open')
                    e.target.classList.remove('open')
                    window.openMegaMenu = null
                    return;
                } else {
                    //closing other menu
                    const menuToClose = document.getElementById(window.openMegaMenu)
                    const buttonToFix = document.querySelector(`[data-menu-id="${window.openMegaMenu}"]`)
                    if (menuToClose) {
                        menuToClose.classList.remove('open')
                    }
                    if (buttonToFix) {
                        buttonToFix.classList.remove('open')
                    }
                }
            }
            // open this menu 
            if (menu) {
                menu.classList.add('open')
                window.openMegaMenu = menuId
                e.target.classList.add('open')
            }
        })
    })

    closeButtons.forEach(button => {
        button.addEventListener('click', e => {
            if (window.openMegaMenu) {
                const menu = document.getElementById(window.openMegaMenu)
                const buttonToFix = document.querySelector(`[data-menu-id="${window.openMegaMenu}"]`)
                menu.classList.remove('open')
                buttonToFix.classList.remove('open')
                window.openMegaMenu = null
            }
        })
    })

    window.addEventListener('click', e => {
        // close open menu or submenu if click is outside
        if (window.openSubMenu) {
            if (!window.openSubMenu.contains(e.target)) {
                window.openSubMenu.classList.remove('open')
                window.openSubMenu = null
            }
        }
        if (window.openMegaMenu) {
            const mega = document.getElementById(window.openMegaMenu)
            const buttonToFix = document.querySelector(`[data-menu-id="${window.openMegaMenu}"]`)

            if (mega && !mega.contains(e.target) && !e.target.classList.contains('mega-menu-toggle')) {
                mega.classList.remove('open')
                buttonToFix.classList.remove('open')
                window.openMegaMenu = null
            }
        }
    })

    jumpToTopButton.addEventListener('click', () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    })

    window.addEventListener('scroll', () => {  
        if (document.body.scrollTop > pageHeight || document.documentElement.scrollTop > pageHeight) {
            jumpToTopButton.classList.add('active')
        } else {
            jumpToTopButton.classList.remove('active')
        }
    })
})()

